import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import routes from "../routes/routes";

/**
 * if country and documentType haven't been selected by user
 * redirect them to the welcome screen
 */
function ProtectedRoute({ children, ...rest }) {
  // redux values
  const country = useSelector((state) => state.country.value);
  const documentType = useSelector((state) => state.documentType.value);

  if (country && documentType) {
    return <Route {...rest}>{children}</Route>;
  }
  return <Redirect to={routes.welcome}></Redirect>;
}

export default ProtectedRoute;
